// How many media people the directory currently lists at an outlet. Written out here so the grid
// and list cards say it the same way.
export default function mediaUserCount(count) {
  const n = count || 0;
  return `${n} media ${n === 1 ? "user" : "users"}`;
}
